export default {
  //request_url:'http://localhost/api/',
  request_url:'https://qtadmin.jobgroup.cn/api/',
}



//////////////////
// WEBPACK FOOTER
// ./static/conf.js
// module id = null
// module chunks = 